import React from 'react'
import UserStore from './UserStore'
import ProductsStore from './ProductsStore'
import CheckoutStore from './CheckoutStore'
import {makeAutoObservable} from 'mobx'

export interface IStores {
  productsStore?: ProductsStore
  checkoutStore?: CheckoutStore
  userStore?: UserStore
}

export default class RootStore {
  constructor() {
    this.userStore = new UserStore(this)
    this.checkoutStore = new CheckoutStore(this, this.productsStore)
    this.productsStore = new ProductsStore(this, this.checkoutStore)
    makeAutoObservable(this)
  }
  public userStore: UserStore
  public productsStore: ProductsStore
  public checkoutStore: CheckoutStore

  // Client is now handled by the Cart API service
}

export const rootStore = new RootStore()
export const StoreContext = React.createContext(rootStore)
